import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

interface SubscriptionContextValue {
  isPro: boolean;
  setIsPro: (isPro: boolean) => void;
  authProviders: string[];
  setAuthProviders: (providers: string[]) => void;
}

const SubscriptionContext = createContext<SubscriptionContextValue | null>(
  null,
);

export function SubscriptionProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isPro, setIsProState] = useState(false);
  const [authProviders, setAuthProviders] = useState<string[]>([]);

  const setIsPro = useCallback((newIsPro: boolean) => {
    setIsProState(newIsPro);
  }, []);

  const value = useMemo(
    () => ({ isPro, setIsPro, authProviders, setAuthProviders }),
    [isPro, setIsPro, authProviders],
  );

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription(): SubscriptionContextValue {
  const ctx = useContext(SubscriptionContext);
  if (!ctx) {
    throw new Error("useSubscription must be used within SubscriptionProvider");
  }
  return ctx;
}
